import React from 'react';
import { DollarSign, Users, Award, Clock } from 'lucide-react';

const benefits = [
  {
    icon: DollarSign,
    title: 'Honest Pricing & Clear Communication',
    description: 'No hidden fees or surprises. We provide detailed estimates and keep you informed every step of the way.'
  },
  {
    icon: Users,
    title: 'Experienced Technicians',
    description: 'Our skilled team has years of experience diagnosing and repairing all makes and models.'
  },
  {
    icon: Award,
    title: 'High-Quality Parts & Warranty',
    description: 'We use only quality parts and stand behind our work with solid warranties for your peace of mind.'
  },
  {
    icon: Clock,
    title: 'Fast Turnaround Time',
    description: 'We understand your time is valuable. We work efficiently to get you back on the road quickly.'
  }
];

const WhyChooseUs = () => {
  return (
    <section className="relative py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-red-600 text-sm font-bold tracking-widest uppercase">Why Choose Us</span>
            <div className="h-0.5 bg-red-600 mt-2 mx-auto"></div>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Your Trusted Auto Repair Partner
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            We're committed to providing exceptional service and building lasting relationships
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group relative bg-neutral-950 border border-white/10 p-8 hover:border-red-600/50 transition-all duration-300"
              style={{ borderRadius: '0px' }}
            >
              {/* Red accent corner */}
              <div className="absolute top-0 left-0 w-1 h-16 bg-red-600 transition-all duration-300 group-hover:h-full"></div>
              
              <div className="flex items-start gap-6">
                {/* Icon */}
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-red-600/10 border border-red-600/30 flex items-center justify-center group-hover:bg-red-600 transition-colors duration-300" style={{ borderRadius: '0px' }}>
                    <benefit.icon className="w-8 h-8 text-red-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                </div>
                
                {/* Content */}
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-white mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-white/70 text-base leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <p className="text-xl text-white/80 mb-6">
            Ready to experience the K&B difference?
          </p>
          <a
            href="tel:7742425144"
            className="inline-flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 text-white px-10 py-4 text-lg font-medium transition-all duration-300 hover:scale-105"
            style={{ borderRadius: '0px', boxShadow: '0 0 30px rgba(255, 0, 0, 0.3)' }}
          >
            Call (774) 242-5144 Today
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;